import React from "react";

const Help = () => {
  return (
    <>
      <video className="help-video" width="100%" controls>
        <source src="" />
      </video>
    </>
  );
};

export default Help;
